module.exports = __webpack_public_path__ + "img/icon-differentials_10.347368e1.svg";